import React from 'react'
import { Field, ErrorMessage, getIn, FieldArray } from 'formik'
import ErrorPopUp from '../../Shared/ErrorPopUp'
import QtyInput from '../../Shared/QtyInput'
import { GoPlus } from 'react-icons/go'
import { AsyncCategorySelect } from '../../Shared/AsyncCategorySelect'
import AsyncBrandSelect from '../../Shared/AsyncBrandSelect'
import AsyncUnitProductSelectByNameAndCodeAndWarehouse from '../../Shared/AsyncUnitProductSelectByNameAndCodeAndWarehouse'
import { IoIosCloseCircleOutline } from 'react-icons/io'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'

const item = { categoryId: '', brandId: '', itemId: '', quantity: 0 }

export default ({ touched, errors, setFieldValue, values, handleBlur }) => (
  <div className="row">
    <div className="col-md-12 col-sm-12">
      <hr />
      {/* <fieldset className="fieldset"> */}
      <div className="warehouse-products-dialog-table">
        <FieldArray
          name="items"
          render={arrayHelpers => (
            <table className="table table-bordered table-hover">
              <thead>
                <tr>
                  <th className="text-center" style={{ width: 50 }}>
                    ردیف
                  </th>
                  <th className="text-center">دسته بندی</th>
                  <th className="text-center">برند</th>
                  <th className="text-center">نام کالا</th>
                  <th className="text-center">مقدار</th>
                  <th
                    className="text-center"
                    style={{ width: 120, borderLeft: '20px solid #fff' }}>
                    حذف از لیست
                  </th>
                </tr>
              </thead>
              <tbody style={{ borderTop: '1px solid #ddd' }}>
                {values.items &&
                  values.items.map((item, index) => (
                    <tr key={'p-' + index}>
                      <td style={{ width: 50 }}>{index + 1}</td>
                      <td>
                        <AsyncCategorySelect
                          // clearable
                          // disabled={true}
                          className="semantic-select-box"
                          categoryType={values.categoryType}
                          defaultValue={item.categoryId}
                          onChange={val => {
                            arrayHelpers.replace(index, {
                              ...item,
                              categoryId: val
                            })
                            // setFieldValue(`items[${index}][categoryId]`, val)
                          }}
                        />
                        <ErrorMessage
                          component={ErrorPopUp}
                          name={`items[${index}].categoryId`}
                          type="select"
                        />
                      </td>
                      <td>
                        <AsyncBrandSelect
                          // clearable
                          // disabled={true}
                          className="semantic-select-box"
                          brandType={
                            values.categoryType === -1
                              ? -1
                              : values.categoryType === 0
                              ? 0
                              : 1
                          }
                          defaultValue={item.brandId}
                          onChange={val => {
                            arrayHelpers.replace(index, {
                              ...item,
                              brandId: val
                            })
                          }}
                        />
                        <ErrorMessage
                          component={ErrorPopUp}
                          name={`items[${index}].brandId`}
                          type="select"
                        />
                      </td>
                      <td>
                        <div style={{ position: 'relative' }}>
                          <AsyncUnitProductSelectByNameAndCodeAndWarehouse
                            unitId={values.unitId}
                            onChange={(val, unitProduct, data_) => {
                              console.log(unitProduct)

                              arrayHelpers.replace(index, {
                                ...item,
                                unitProductId: val,
                                unitProduct: unitProduct,
                                categoryType: unitProduct.category.categoryType,
                                categoryId: unitProduct.categoryId,
                                brandId: unitProduct.brandId,
                                data: data_
                              })
                            }}
                            defualtValue={item.unitProductId}
                            defualtData={item.data}
                            categoryId={item.categoryId}
                            brandId={item.brandId}
                            warehouseId={values.unitId}
                          />
                          <ErrorMessage
                            component={ErrorPopUp}
                            name={`items[${index}].unitProductId`}
                            style={{ top: '-12px' }}
                          />
                        </div>
                      </td>
                      <td>
                        <div className="qty-container">
                          {item.unitProduct ? (
                            <QtyInput
                              disabled={
                                item.unitProduct &&
                                item.unitProduct.conversionUnit
                              }
                              measurementType={
                                item.unitProduct &&
                                item.unitProduct.measurementType
                              }
                              subMeasurementType={
                                item.unitProduct &&
                                item.unitProduct.subMeasurementType
                              }
                              conversionUnit={
                                item.unitProduct &&
                                item.unitProduct.conversionUnit
                              }
                              onChange={(val, subVal) => {
                                arrayHelpers.replace(index, {
                                  ...item,
                                  quantity: val,
                                  subQuantity: subVal
                                })
                              }}
                              defualtValue={item.quantity}
                              defualtSubValue={item.subQuantity}
                            />
                          ) : (
                            ''
                          )}
                          <ErrorMessage
                            component={ErrorPopUp}
                            name={`items[${index}].quantity`}
                            style={{ top: '-12px' }}
                          />
                        </div>
                      </td>
                      <td style={{ width: 120 }}>
                        <IconButton
                          aria-label="delete"
                          size="small"
                          onClick={() => arrayHelpers.remove(index)}>
                          <IoIosCloseCircleOutline
                            size="24px"
                            color="#e8055a"
                          />
                        </IconButton>
                      </td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan="7">
                    <Button
                      disabled={!values.unitId}
                      variant="contained"
                      color="primary"
                      size="medium"
                      onClick={() =>
                        arrayHelpers.push({
                          unitProductId: '',
                          unitProduct: undefined,
                          quantity: undefined
                        })
                      }>
                      <GoPlus size="20px" />
                    </Button>
                  </th>
                </tr>
              </tfoot>
            </table>
          )}
        />
      </div>
      {/* </fieldset> */}
      {!Array.isArray(errors.items) && (
        <ErrorMessage component={ErrorPopUp} name="items" />
      )}
    </div>
  </div>
)
